import * as Comlink from "comlink";

export const createWorker = (url: URL | string) => {
  const resolved = new URL(url, import.meta.url);

  // Same-origin: the browser lets us construct the Worker directly.
  if (resolved.origin === self.location.origin) {
    return new Worker(resolved, { type: "module" });
  }

  // Cross-origin (assets served from a CDN host): the Worker constructor
  // refuses a cross-origin top-level script regardless of CORS headers. Bootstrap
  // it from a same-origin blob that re-imports the real script. The CDN serves
  // CORS headers, so the module import inside the worker — and all of its
  // transitive imports, which resolve against the CDN origin — succeed.
  const blobUrl = URL.createObjectURL(
    new Blob([`import ${JSON.stringify(resolved.href)};`], {
      type: "text/javascript",
    }),
  );
  const worker = new Worker(blobUrl, { type: "module" });
  // Revoke once the worker is torn down (hooks.ts calls terminate()); until then
  // the blob must stay alive so the worker can fetch its top-level script.
  const terminate = worker.terminate.bind(worker);
  worker.terminate = () => {
    URL.revokeObjectURL(blobUrl);
    terminate();
  };
  return worker;
};

export const wrap = <T>(worker: Worker) => {
  return Comlink.wrap<T>(worker);
};

export const expose = <T>(api: T) => {
  return Comlink.expose(api);
};
